import { PostHogProvider } from "@posthog/react";
import { createRoot } from "react-dom/client";
import { initPostHog } from "./analytics/posthog";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./theme/ErrorBoundary";
import { bootstrapNativeAuthBridge } from "./utils/nativeAuthBridge";
import { bootstrapNativeCheckoutBridge } from "./utils/nativeCheckoutBridge";
import { bootstrapNativeWebViewInsets } from "./utils/nativeWebViewInsets";

// Load timings: dom_ready set in index.html (before any bundle); react_ready set below; auth_bootstrap in AuthContext
if (typeof window !== "undefined") {
  window.__loadTimings = window.__loadTimings ?? {};
  bootstrapNativeWebViewInsets();
  bootstrapNativeAuthBridge();
  bootstrapNativeCheckoutBridge();
}

// Initialize before render so the SDK is ready for the first effect that captures.
const posthogClient = initPostHog();

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  // <React.StrictMode>
  <ErrorBoundary showDebugInfo={process.env.NODE_ENV === "development"}>
    {posthogClient ? (
      <PostHogProvider client={posthogClient}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </ErrorBoundary>
  // </React.StrictMode>
);

if (typeof window !== "undefined" && window.__loadTimings) {
  requestAnimationFrame(() => {
    if (window.__loadTimings && window.__loadTimings.react_ready_ms == null) {
      window.__loadTimings.react_ready_ms = performance.now();
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
